// For Firebase JS SDK v7.20.0 and later, measurementId is optional

import firebase from "firebase";
import 'firebase/firestore';
const firebaseConfig = {
    apiKey: "AIzaSyAIAZDBWGjpPcIwSPoj39Wx_mkTzYacqAU",
    authDomain: "fir-1f003.firebaseapp.com",
    projectId: "fir-1f003",
    storageBucket: "fir-1f003.appspot.com",
    messagingSenderId: "602960739834",
    appId: "1:602960739834:web:46b0e4413a33573b737843",
    measurementId: "G-9N97QNYDHM"
  };

  const firebaseApp =  firebase.initializeApp(firebaseConfig);

  const db =  firebaseApp.firestore();
  const auth =  firebase.auth();

  export { db, auth};